import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export abstract class BaseStore {
  readonly #loading = signal(false);
  readonly #error = signal<string | null>(null);

  readonly loading = this.#loading.asReadonly();
  readonly error = this.#error.asReadonly();

  setLoading(loading: boolean): void {
    this.#loading.set(loading);
  }

  setError(error: string | null): void {
    this.#error.set(error);
  }

  resetBaseState(): void {
    this.setLoading(false);
    this.setError(null);
  }
}
